/** @format */

import React from "react";

// Configurator progress: one thin segment per step (filled up to the current
// one) with the step number and name underneath. Done and current steps are
// clickable; later steps are not.
function Stepper({ currentStep, steps = [], onStepClick }) {
	return (
		<nav aria-label="Progress Steps">
			<ol
				className="grid gap-1.5"
				style={{
					gridTemplateColumns: `repeat(${steps.length || 1}, minmax(0, 1fr))`,
				}}
			>
				{steps.map((step) => {
					const isActive = step.page === currentStep;
					const isCompleted = step.page < currentStep;
					const reached = isActive || isCompleted;

					return (
						<li key={step.page} className="min-w-0">
							<button
								type="button"
								onClick={() => onStepClick(step)}
								disabled={!reached} // Allow clicking completed or active steps
								className="group w-full text-left disabled:cursor-default focus:outline-none focus-visible:ring-1 focus-visible:ring-[#141414] focus-visible:ring-offset-2"
								aria-current={isActive ? "step" : undefined}
							>
								<span
									className={`block h-[2px] transition-colors duration-200 ${
										reached ? "bg-[#141414]" : "bg-[#D6D3CC]"
									}`}
									aria-hidden="true"
								/>
								{/* Number over name, so long names ("Bottom Bar") wrap
								    instead of being cut off in six narrow columns.
								    Phones show one "Step N of M" line below instead. */}
								<span className="mt-2 hidden sm:flex flex-col min-w-0">
									<span
										className={`text-[10px] sm:text-[11px] font-normal tabular-nums ${
											reached ? "text-[#141414]" : "text-[#B8B3A9]"
										}`}
									>
										{String(step.page).padStart(2, "0")}
									</span>
									<span
										className={`mt-0.5 text-[11px] sm:text-[13px] leading-tight break-words transition-colors duration-200 ${
											isActive
												? "text-[#141414] font-semibold"
												: isCompleted
												? "text-[#141414] font-normal group-hover:underline underline-offset-4 decoration-1"
												: "text-[#B8B3A9] font-normal"
										}`}
									>
										{step.name}
									</span>
								</span>
							</button>
						</li>
					);
				})}
			</ol>
			<p className="sm:hidden mt-2.5 text-[13px] text-[#5E5E5A]">
				Step {Math.max(1, steps.findIndex((s) => s.page === currentStep) + 1)}{" "}
				of {steps.length}
				<span className="font-normal"> · </span>
				<span className="font-semibold text-[#141414]">
					{steps.find((s) => s.page === currentStep)?.name}
				</span>
			</p>
		</nav>
	);
}

export default Stepper;
